export function hasEventStarted(ev) {
    return ev.isLive && ev.liveStartCountdown <= 0;
}
//# sourceMappingURL=hasEventStarted.js.map